import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import HeaderTwo from '../../components/HeaderTwo';
import GoogleMap from './GoogleMap';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/contact.js';
import { useTranslation } from 'react-i18next';

function Contact() {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null

    useEffect(() => {
        const form = document.getElementById("form_contact");

        form.addEventListener("submit", formSubmit);

        function formSubmit(e) {
            e.preventDefault();

            const name = document.getElementById("contact_name").value.trim();
            const email = document.getElementById("contact_email").value.trim();
            const subject = document.getElementById("contact_subject").value.trim();
            const message = document.getElementById("contact_message").value.trim();
            const phone = document.getElementById("contact_phone").value.trim();

            // Validate other fields (name, email, subject, and message)
            if (name === "") {
                setError("contact_name", "Name can't be blank");
            } else {
                setSuccess("contact_name");
            }

            if (email === "") {
                setError("contact_email", "Email can't be blank");
            } else if (!isEmail(email)) {
                setError("contact_email", "Not a valid email");
            } else {
                setSuccess("contact_email");
            }

            if (subject === "") {
                setError("contact_subject", "Subject can't be blank");
            } else {
                setSuccess("contact_subject");
            }

            if (message === "") {
                setError("contact_message", "Message can't be blank");
            } else {
                setSuccess("contact_message");
            }

            // Validate if the phone is filled, but don't make it mandatory
            if (phone && phone === "") {
                setError("contact_phone", "Phone number can't be blank if provided");
            } else {
                setSuccess("contact_phone");
            }

            // If all fields are valid, send email via EmailJS
            if (name && email && subject && message) {
                setIsSubmitting(true);
                emailjs
                    .sendForm(
                        'service_5bmb55p',  // Service ID
                        'template_52we9zs',  // Template ID
                        form,
                        'aZs2o4wJvgOcTpZl8'  // Public Key
                    )
                    .then(
                        (result) => {
                            setSubmitStatus('success');
                            console.log(result.text);
                        },
                        (error) => {
                            setSubmitStatus('error');
                            console.log(error.text);
                        }
                    )
                    .finally(() => setIsSubmitting(false)); // Reset button status after submission
            }
        }

        function setError(inputId, message) {
            const formControl = document.getElementById(inputId).parentElement;
            const errorMsg = formControl.querySelector(".contact_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(inputId) {
            const formControl = document.getElementById(inputId).parentElement;
            formControl.className = "form-control success";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }
    }, []);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                        <Row>
                            <Col md="4">
                                <div className="contact-box-title">
                                    <h4>{t('contact.info_title')}</h4>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-map-marker"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t('contact.location_title')}</h5>
                                        <p>635, Road: 29, Block: L, Bashundhara R/A, Dhaka, Bangladesh.</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t('contact.email_title')}</h5>
                                        <p>shahadat@cozycouture.com</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{t('contact.phone_title')}</h5>
                                        <p>+88 01710 668 174</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="8">
                                <div className="contact-form">
                                    <div className="form-title">
                                        <h4>{t('contact.form_title')}</h4>
                                    </div>
                                    <div className="form-box">
                                        {submitStatus === 'success' && <p className="success">{t('contact.sent_success')}</p>}
                                        {submitStatus === 'error' && <p className="error">{t('contact.sent_error')}</p>}
                                        <form id="form_contact" className="form">
                                            <Row>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input
                                                            type="text"
                                                            name="from_name"
                                                            placeholder={t('contact.placeholder_name')}
                                                            id="contact_name"
                                                        />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input
                                                            type="email"
                                                            name="from_email"
                                                            placeholder={t('contact.placeholder_email')}
                                                            id="contact_email"
                                                        />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input
                                                            type="text"
                                                            name="phone_number"
                                                            placeholder={t('contact.placeholder_phone')}
                                                            id="contact_phone"
                                                        />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input
                                                            type="text"
                                                            name="subject"
                                                            placeholder={t('contact.placeholder_subject')}
                                                            id="contact_subject"
                                                        />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <textarea
                                                            name="message"
                                                            id="contact_message"
                                                            placeholder={t('contact.placeholder_message')}
                                                        ></textarea>
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <button disabled={isSubmitting}>
                                                        {isSubmitting ? t('contact.sending') : t('contact.send')}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Google Map */}
                    <GoogleMap />
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    );
}

export default Contact;
